import SectionWrapper from "@/partials/sections/Section/SectionWrapper";
import CardImage from "./components/CardImage";
import CardInfo from "./components/CardInfo";
import FlexSection from "@/partials/sections/Section/FlexSection";

export default function PractitionersCard({ revenueGrowth }) {
  return (
    <SectionWrapper extraClass={" pl-0 md:pl-0"}>
      <FlexSection extraClass={"md:flex-row flex-col justify-between"}>
        {revenueGrowth?.map((item) => (
          <div
            key={item?._id}
            className="flex justify-start md:justify-center items-center gap-6 pb-8 md:pb-0  pl-0 md:pl-0"
          >
            <CardImage item={item} />
            <CardInfo item={item} />
          </div>
        ))}
      </FlexSection>
    </SectionWrapper>
  );
}
